import { Box, Typography } from '@mui/material';
import { zonedTimeToUtc } from 'date-fns-tz';

export function maintWindow() {
  const start = zonedTimeToUtc('2026-05-30T23:30:00', 'Europe/London')
  const end = zonedTimeToUtc('2026-05-31T01:30:00', 'Europe/London')
  const userUtcDate = new Date()

  return userUtcDate >= start && userUtcDate <= end
}

const address = window.location.href
const isVeezu = address.includes('veezu')

export function MaintMessage() {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100dvw',
        height: '100dvh',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FFFBef',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '40dvw',
          gap: '40px',
        }}
      >
        <img
          width="500"
          src="/images/systemdown.png"
          alt="Two vehicles held up by roadworks while a worker fixes the issue"
        />
        <Typography
          variant="h6"
          sx={{ textAlign: 'center', textWrap: 'balance' }}
        >
          Our application is currently unavailable for planned maintenance, and
          we are working hard to bring it back online as soon as possible.
        </Typography>
        {!isVeezu ? (
          <Typography
            variant="h6"
            sx={{ textAlign: 'center', textWrap: 'balance' }}
          >
            If you need to book a vehicle urgently, please call{' '}
            <a href="tel:+443450042099">+44 345 004 2099</a> or, if you are
            calling from outside the UK, please dial{' '}
            <a href="tel:++442039258861">+44 203 925 8861</a>
          </Typography>
        ) : (
          <Typography
            variant="h6"
            sx={{ textAlign: 'center', textWrap: 'balance' }}
          >
            If you need to book a vehicle urgently, please call{' '}
            <a href="tel:+441743249579">+44 1743 249579</a>
          </Typography>
        )}
      </Box>
    </Box>
  )
}
